import { createSlice } from '@reduxjs/toolkit';
import { IInitialdASHBOARDcHARTData } from './types';

const SLICE_NAME = 'DASHBOARD_CHARTS_SLICE';

export const initialState: IInitialdASHBOARDcHARTData = {
  loading: false,
  dashboard: null,
  charts : null,
  dashboardsList : null,
  dashboardsListLoading:false,
  setSelectedCompany : null,
  loadingSetSelectedCompany : true,
  setSelectedCompanyError : ""
};

const dashboardChartsSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    setSelectedDashboard: (state, { payload }) => {
      state.loading = true;
      state.charts = initialState.charts;
      state.dashboard = initialState.dashboard;
    },
    setSelectedDashboardSuccess: (state, { payload }) => {
      state.loading = false;
      state.charts = payload.charts;
      state.dashboard = payload.dashboard;
    },
    setSelectedDashboardError: (state) => {
      state.loading = false;
      state.charts = initialState.charts;
      state.dashboard = initialState.dashboard;
    },

    getDashbardsList : (state , {payload})=> {
      state.dashboardsListLoading = true;
     state. dashboardsList = initialState.dashboardsList
    },
    getDashbardsListSuccess : ( state , { payload})=> {
      state.dashboardsListLoading = false;
      state.dashboardsList = payload
    },
    getDashbardsListError : ( state)=> {
      state.dashboardsListLoading = false;
    },

    setSelectedCompanyofDashborad : ( state , { payload }) => {
      state.setSelectedCompany = initialState.setSelectedCompany,
      state.loadingSetSelectedCompany = true
    },
    setSelectedCompanyofDashboradSuccess : ( state , { payload }) => {
      state.setSelectedCompany = payload,
      state.loadingSetSelectedCompany = false
    },
    setSelectedCompanyofDashboradError : ( state , { payload }) => {
      state.setSelectedCompany = initialState.setSelectedCompany,
      state.loadingSetSelectedCompany = false,
      state.setSelectedCompanyError = payload
    }
  },
});

export default dashboardChartsSlice;

 